<!--suppress JSUnresolvedVariable -->
<template>
    <div>
        <template v-if="training.isNotAccessible">
            <CRow class="justify-content-center mb-4" :training-id="training.id">
                <CCol xl="6" lg="7">
                    <CCard>
                        <CCardHeader>
                        </CCardHeader>
                        <CCardBody>
                            <template v-if="training.isNotAllowed">
                                <p>Access to video {{ training.id }} is restricted due to its privacy settings. Ask the author to add access for you
                                    (username: <b>{{ store.myUser.username }}</b>) in the privacy settings of the video.</p>
                                <br>
                                <p>Meantime you can watch other videos in the
                                    <CLink :to="{ name: 'feed'}">public</CLink>
                                    section.
                                </p>
                            </template>
                            <template v-else>
                                <p v-if="training.isDeleted">Video {{ training.id }} was deleted.</p>
                                <p v-if="training.isNotFound">Video {{ training.id }} does not exist.</p>
                                <p>You can watch other videos in the
                                    <CLink :to="{ name: 'feed'}">public</CLink>
                                    section.
                                </p>
                            </template>
                        </CCardBody>
                    </CCard>
                </CCol>
            </CRow>
        </template>
        <template v-else>
            <CRow v-if="vPR"
                  :class="fullscreenMode ? 'fullscreen-mode' : 'training justify-content-center mb-4'"
                  :training-id="training.id"
                  video-id="video.id"
                  :key="vPR.id">
                <CCol v-bind="columnTrainingsProps">
                    <CCard>
                        <CCardHeader  :id="CCardHeaderId" :style="showPanel === 'main' ? 'padding: 0.45rem 1.25rem' : ''">
                            <template v-if="showPanel === 'main'">
                                <CRow v-if="!showDeleteQuestionMainPanel">
                                    <CCol col="9" class="rowing-header-buttons">
                                        <CButton v-for="seatNum in seatNums" :key="seatNum+20"
                                                 :class="{
                                                            'seats-btn': true,
                                                            'px-2': true,
                                                            'activeTabButton': 'seat' + seatNum === activeTab,
                                                            'noblur': true
                                                         }"
                                                 color='light'
                                                 @click="activeTab='seat' + seatNum"
                                        >
                                            {{ seatName(seatNum) }}
                                        </CButton>
                                        <CButton
                                            v-if="sourceAllowedFlag"
                                            :class="{
                                                            'source-btn': true,
                                                            'px-2': true,
                                                            'activeTabButton': 'source' === activeTab,
                                                            'noblur': true
                                                         }"
                                            color='light'
                                            @click="activeTab='source'"
                                        >
                                            Source
                                        </CButton>
                                        <CButton
                                            v-if="showCompareTab"
                                            :class="{
                                                              'compare-btn': true,
                                                              'px-2': true,
                                                              'activeTabButton': 'compare' === activeTab,
                                                              'noblur': true,
                                                              'blue-tab': true,
                                                              'disabled': !isCompare2xAvailable
                                                           }"
                                            color='light'
                                            @click="clickCompare"
                                            v-c-tooltip="isCompare2xAvailable ? '' : 'Out of your plan'"
                                        >
                                          Compare seats
                                        </CButton>

                                        <CButton
                                            v-if="showCompareErgTab"
                                            :class="{
                                                              'compare-btn': true,
                                                              'px-2': true,
                                                              'activeTabButton': 'compareErg' === activeTab,
                                                              'noblur': true,
                                                              'blue-tab': true,
                                                              'disabled': !isCompare1xAvailable
                                                           }"
                                            color='light'
                                            @click="clickCompareErg"
                                            v-c-tooltip="isCompare1xAvailable ? '' : 'Out of your plan'"
                                        >
                                            Compare with others
                                        </CButton>
                                        <SelectAthlete
                                            v-if="'compareErg' === activeTab" :training="training"
                                            @selectTraining="changedComparedAthlete"
                                        />

                                        <CButton
                                            v-if="['compare', 'compareErg'].includes(activeTab) && store.myUser.isSuperuser"
                                            color="info"
                                            class="fullscreen-mode-btn"
                                            @click="toggleFullscreen()">Fullscreen</CButton>

                                        <Spinner class="ml-3 mr-3" style="display: inline-block; margin-bottom: -11px"
                                                 v-if="activeTabVideoAvailableFlag && processingInProgress"/>
                                        <div v-if="store.showStaffControls">
                                            training id:
                                            <CLink :href="`${backendURL}/rowdmin/rowerup_api/training/${training.id}/change/`">
                                                {{ training.id }}
                                            </CLink>
                                            {{
                                                training.accessForAll ? '' : ', private'
                                            }}{{ training.forDelete ? ', deleted' : '' }}

                                            <CLink class="ml-2" v-if="video.videoProcessing && video.videoProcessing.transcodedVideo"
                                                   @click="showTranscodedVideoPlayer = !showTranscodedVideoPlayer"
                                                   :class="{'active-admin-item': showTranscodedVideoPlayer}">[Base video]
                                            </CLink>
                                        </div>
                                    </CCol>
                                    <CCol col="3" class="training-menu d-flex align-items-center justify-content-end">
                                            <span class="mb-0 video-header__text text-nowrap">{{
                                                    training.equipmentType === 'ERG' ? `Erg: ${training.ergType}` : `Boat: ${training.boatType.slice(4).toLowerCase().replace('_p', '+').replace('_m', '-')}`
                                                }}</span>
                                        <CDropdown
                                            inNav
                                            class="c-header-nav-items ml-2"
                                            placement="bottom-end"
                                            add-menu-classes="pt-0"
                                        >
                                            <template #toggler>
                                                <!--suppress HtmlUnknownTag -->
                                                <CIcon style="margin-right:-4px; cursor: pointer" name="cilMenu" height="30"/>
                                            </template>

                                            <CDropdownItem v-if="this.feedType !== 'training'"
                                                           :to="{name: 'training', params: {trainingId: training.id, activeTab, trainingParams: trainingParamsArrForUrl}}">
                                                <!--suppress HtmlUnknownTag -->
                                                <CIcon class="mr-2" name="cilExternalLink"/>
                                                Go to post
                                            </CDropdownItem>
                                            <CDropdownItem v-clipboard:copy="trainingUrl">
                                                <!--suppress HtmlUnknownTag -->
                                                <CIcon class="mr-2" name="cilLink"/>
                                                Copy link
                                            </CDropdownItem>
                                            <template v-if="store.myUser.id===training.owner.id">
                                                <div class="dropdown-divider"></div>
                                                <CDropdownItem @click="showPanel='trainingSettings'">
                                                    <!--suppress HtmlUnknownTag -->
                                                    <CIcon class="mr-2" name="cilPencil"/>
                                                    Change privacy
                                                </CDropdownItem>
                                                <CDropdownItem @click="showDeleteQuestionMainPanel=true"
                                                >
                                                    <!--suppress HtmlUnknownTag -->
                                                    <CIcon class="mr-2" name="cilX"/>
                                                    Delete video
                                                </CDropdownItem>
                                            </template>
                                            <div class="dropdown-divider"></div>
                                            <CDropdownItem disabled>
                                                <!--suppress HtmlUnknownTag -->
                                                Training id: {{ training.id }}
                                            </CDropdownItem>
                                        </CDropdown>
                                    </CCol>
                                </CRow>
                                <div v-else>
                                    Do you want to delete this video?
                                    <CButton @click="deleteTraining" color="danger" class="p-1 ml-1" style="line-height:1">
                                        YES
                                    </CButton>
                                    <CButton @click="showDeleteQuestionMainPanel=false" color="success" class="p-1 ml-1" style="line-height:1">
                                        NO
                                    </CButton>
                                </div>
                            </template>
                            <div v-else>
                                        <span v-if="showPanel==='trainingSettings'">
                                            Sharing and privacy settings
                                        </span>
                                <span v-else-if="showPanel==='warningsInfo'">
                                            Footage quality warnings
                                        </span>
                                <CButton @click="showPanel='main'" class="p-0 float-right">
                                    <!--suppress HtmlUnknownTag -->
                                    <CIcon size="lg" name="cilX"/>
                                </CButton>
                            </div>
                        </CCardHeader>
                        <CCardBody>
                            <template v-if="showPanel==='trainingSettings'">
                                <CRow class="justify-content-center align-items-center">
                                    <CCol sm="8">
                                        <CForm @submit.prevent="changePrivacy">
                                            <CRow v-for="seatNum in seatNums" :key="seatNum"
                                                  class="video-select justify-content-between align-items-center mb-2">
                                                <CCol sm="6" :style="participantsQty > 1 ? 'margin-bottom: -22px' : ''">
                                                    <label class="mb-0" v-if="seatNum === 1">
                                                        <template v-if="participantsQty !== 1">
                                                            Set the crew
                                                            <br>
                                                            (optional)
                                                        </template>
                                                        <template v-else>
                                                            Who is on video
                                                        </template>
                                                    </label>
                                                </CCol>
                                                <CCol sm="6">
                                                    <v-select
                                                        :class="{
                                                                    'profile-select': true,
                                                                    'mt-4': seatNum === 1 && participantsQty !== 1,
                                                                    'mt-sm-0': seatNum === 1 && participantsQty !== 1
                                                                }"
                                                        style="height:35px"
                                                        :options="participantOptions[seatNum]"
                                                        :placeholder="participantSelectorPlaceholder[seatNum]"
                                                        @search:blur="setParticipantSelectorPlaceholder(false, seatNum)"
                                                        @search:focus="setParticipantSelectorPlaceholder(true, seatNum)"
                                                        @search="fetchParticipantOptions($event, arguments[1], seatNum, participant, participantCustomName)"
                                                        label="username"
                                                        @input="setParticipant($event, seatNum)"
                                                        :value="participant[seatNum] || participantCustomName[seatNum]"
                                                    >
                                                        <template #list-footer="{filteredOptions, search}">
                                                            <li class="p-3"
                                                                v-if="filteredOptions.length === 1 && search && filteredOptions[0].id.startsWith('@')"
                                                                style="text-align: center">
                                                                Click to set the custom name
                                                            </li>
                                                            <li class="p-3" v-if="filteredOptions.length > 1 && search">
                                                                Select from the list or click to set the custom name
                                                            </li>
                                                            <li class="p-3" v-if="!search">
                                                                Search username or input custom name
                                                            </li>
                                                        </template>
                                                        <template #no-options="{}">
                                                            <div></div>
                                                        </template>
                                                        <template #search="{events, attributes}">
                                                            <!--suppress HtmlFormInputWithoutLabel -->
                                                            <input class="vs__search" v-on="events" v-bind="attributes" maxlength="50"/>
                                                        </template>
                                                        <template #option="option">
                                                            <template v-if="option.id && option.id !== '0'">{{ option.username }}</template>
                                                            <template v-else><i>{{ option.username }}</i></template>
                                                        </template>
                                                    </v-select>
                                                </CCol>
                                            </CRow>
                                            <label class="mt-2">
                                                Sharing and privacy
                                            </label>
                                            <CRow class="radio-profile mb-1">
                                                <CCol class="mb-1">
                                                    <CInputRadioGroup
                                                        custom
                                                        class="home-form__radio d-flex flex-wrap mt-0"
                                                        :options="privacyOptions"
                                                        :checked.sync="privacy"
                                                        required
                                                        @update:checked="onSelectorChanged"
                                                    />
                                                </CCol>
                                            </CRow>
                                            <CRow v-for="(customPrivacyId, i) in customPrivacyIds" :key="customPrivacyId+10"
                                                  class="mb-2 justify-content-between align-items-center">
                                                <CCol sm="6">
                                                    <label class="mb-0" v-if="i === 0">Share with more people</label>
                                                </CCol>
                                                <CCol sm="6">
                                                    <v-select
                                                        class="profile-select"
                                                        style="height:35px"
                                                        :placeholder="i === 0 ? 'Select user' : 'Share with user'"
                                                        @search="fetchCustomPrivacyOptions"
                                                        @input="setCustomPrivacyUser($event, customPrivacyId)"
                                                        :options="customPrivacySearchOptions"
                                                        :value="customPrivacyOpts[customPrivacyId]"
                                                        label="username"
                                                    >
                                                        <template #list-footer="{filteredOptions, search}">
                                                            <li class="p-1 pl-3 pr-3" v-if="!search">
                                                                Search username
                                                            </li>
                                                            <li class="p-1 pl-3 pr-3" v-else-if="search && !filteredOptions.length">
                                                                User not found
                                                            </li>
                                                        </template>
                                                        <template #no-options="{}">
                                                            <div></div>
                                                        </template>
                                                        <template #search="{events, attributes}">
                                                            <!--suppress HtmlFormInputWithoutLabel -->
                                                            <input class="vs__search" v-on="events" v-bind="attributes" maxlength="50"/>
                                                        </template>
                                                    </v-select>
                                                </CCol>
                                            </CRow>

                                            <CRow>
                                                <CCol sm="8" class="text-right">
                                                    <CButton
                                                        style="min-width:150px"
                                                        color="success"
                                                        class="px-5 mt-3"
                                                        type="submit"
                                                    >
                                                        Save
                                                    </CButton>
                                                </CCol>
                                            </CRow>
                                        </CForm>
                                    </CCol>
                                </CRow>
                            </template>
                            <template v-else-if="showPanel==='warningsInfo'">
                                <ul>
                                    <li v-for="(warning, slug) in warningsInfo" :key="slug" :class="'rowing-analysis-warning-level-' + warning.level">
                                        <template v-if="slug === 'small_pose_2d_median_back_length_pixels'">
                                            <b>{{ warning.level > 1 ? 'Small' : 'Moderate' }} athlete size on video ({{ Math.floor(warning.val) }}
                                                pixels).</b>
                                            {{ 'athlete_too_close' in warningsInfo ? 'S' : 'Put camera closer or s' }}et camera to the
                                            higher resolution (current resolution is: {{
                                                warning.src_frame_size_wh[0]
                                            }}x{{ warning.src_frame_size_wh[1] }}). An athlete size of more than
                                            {{ warning.target[1] }} pixels is acceptable, and more than {{ warning.target[2] }} pixels is perfect.<br>
                                            Note: messengers and social networks shrink video quality.
                                        </template>
                                        <template v-if="slug === 'original_video_was_downscaled_before_processing'">
                                            <b>Video resolution is too high ({{ warning.target[0] }}x{{ warning.target[1] }}).</b>
                                            The video was downscaled to {{ warning.val[0] }}x{{ warning.val[1] }}
                                            before processing because the maximum supported resolution is 3840x3840 (4k).
                                        </template>
                                        <template v-if="slug === 'video_is_too_long'">
                                            <b>Video is longer than needed ({{ warning.val.toFixed(1) }}s).</b>
                                            Only the first {{ warning.target }} seconds of the video are processed.
                                        </template>
                                        <template v-if="slug === 'extremely_low_pose_2d_found_ds_percent_after_trim'">
                                            <b>A human was hardly recognized at {{ (100-warning.val).toFixed(0) }}% frames for some reason.</b> Usually, it
                                            happens because of poor light conditions, clothes with the same color as the background, occlusions,
                                            or the low quality of the video.
                                        </template>
                                        <template v-if="slug === 'athlete_too_close'">
                                            <template v-if="warning.level === 2">
                                                <b>The athlete is quite close to the camera.</b> Perspective distortions may do results inaccurate.
                                            </template>
                                            <template v-else>
                                                <b>Moderate distance to the camera.</b> The distance between athlete and camera is ok. However, to
                                                avoid
                                                even minimal perspective distortion, the athlete should be a little further from the camera.
                                            </template>
                                        </template>
                                        <template v-if="slug === 'high_pose_2d_found_trimmed_duration'">
                                            <b>Input video was not trimmed to the right fragment.</b> Please,
                                            trim the input video to the fragment where the athlete rows in a lateral position on all frames before
                                            uploading
                                        </template>
                                        <template v-if="slug === 'slow_motion_detected'">
                                            <b>Slow-motion video detected.</b> Please, switch to the regular camera mode for the best accuracy.
                                        </template>
                                        <template v-if="slug === 'short_dataset'">
                                            <b>The input video is {{ warning.level > 1 ? 'too' : 'a bit' }} short
                                                ({{ (Math.floor(warning.val * 10) / 10).toFixed(1) }}s).</b> It is recommended to upload approximately
                                            {{ warning.target[2] }}-{{ warning.target[2] + 5 }}s videos.
                                        </template>
                                        <template v-if="slug === 'high_strokes_durations_minmax_ratio'">
                                            <b>Variable stroke pace detected.</b> Keep the stable stroke rate on the input video for better accuracy.
                                        </template>
                                        <template v-if="slug === 'high_strokes_pose_proj_median_back_lengths_minmax_ratio'">
                                            <b>Variable athlete{{ participantsQty > 1 ? 's' : '' }} scale detected.</b> Keep the stable distance to
                                            the
                                            athlete for better accuracy.
                                        </template>
                                        <template v-if="slug === 'high_strokes_minmax_mean_pose_3d_angle_deviations_from_y3d_diff'">
                                            <b>Variable athlete{{ participantsQty > 1 ? 's' : '' }} view angle.</b> Don't move the camera around the
                                            athlete
                                            during filming.
                                        </template>
                                        <template v-if="slug === 'big_y_angle'">
                                            <b>The video is not lateral enough.</b> Please, make a strictly lateral video for good accuracy.
                                        </template>
                                        <template v-if="slug === 'pose_2d_not_in_frame_with_padding_high_percent'">
                                            <b>The pose is not totally in the frame at some frames.</b> Keep all body parts in
                                            the frame during filming for the best accuracy.
                                        </template>
                                    </li>
                                </ul>
                                <p class="mt-4 ml-4">Check the <a :href="faqURL + '#doing-right-footage'" target="_blank">Doing right footage</a>
                                    section
                                    of the FAQ for more details.
                                </p>
                            </template>
                            <div v-else>
                                <template v-if="vPR">

                                    <RowingVideo
                                        :training="training"
                                        :compareTraining="compareWithTraining"
                                        :doPreload="doPreload"
                                        :feedType="feedType"
                                        :tabs="tabs"
                                        :activeTab="activeTab"
                                        :activeSeatNum="activeSeatNum"
                                        :trainingUrl="trainingUrl"
                                        :trainingParamsArrForUrl="trainingParamsArrForUrl"
                                        :trainingParams="trainingParams"
                                        :myUser="store.myUser"
                                    />

                                    <CRow v-if="!activeTabVideoAvailableFlag || vPR.criticalErrorFlag"
                                          style="height:400px"
                                          class="video-analyzing align-items-center"
                                    >
                                        <template v-if="!activeTabVideoAvailableFlag && !vPR.criticalErrorFlag">
                                            <CCol sm="6" md="6" class="pl-4">
                                                <CProgress height="20px" color="info" show-percentage
                                                           :value="vPR.progress || 4"/>
                                            </CCol>
                                            <CCol sm="6" md="6">
                                                <h3 style="color:#2eb85c" class="mb-0">
                                                    <strong style="font-weight:600" v-if="vPR.strokesQty === null">
                                                        Analyzing video...
                                                    </strong>
                                                    <strong style="font-weight:600"
                                                            v-else-if="this.activeSeatNum && vPR['reportPdf' + this.activeSeatNum] === null">
                                                        Generating pdf report...
                                                    </strong>
                                                    <strong style="font-weight:600" v-else>
                                                        Generating video report...
                                                    </strong>
                                                </h3>
                                            </CCol>
                                        </template>
                                        <div>
                                            <h3 class="m-3" style="width: 100%" v-if="vPR.criticalErrorFlag">
                                                Processing failed</h3>
                                            <p v-for="error in vPR.errors" class="text-danger m-3">
                                                <template>
                                                    {{ JSON.parse(error).options.text }}
                                                </template>
                                            </p>
                                            <template v-if="vPR.criticalErrorFlag">
                                                <p class="text-danger mt-5 ml-3 mr-3">1. Check that video was recorded from or trimmed to the
                                                    LATERAL point of observation, lasts approx. 15s, and includes at least 4 strokes.</p>
                                                <p class="text-danger ml-3 mr-3">2. Check that ALL PARTS of
                                                    {{ participantsQty > 1 ? "athletes' bodies" : "athlete's  body" }} like arms,
                                                    elbows, shins,
                                                    head are totally in video fragment on each frame.</p>
                                                <p class="text-danger ml-3 mr-3 mb-5">3.
                                                    <template v-if="warningsInfo && Object.keys(warningsInfo).length">Check footage quality <a
                                                        href="#"
                                                        @click.prevent="toggleWarningsInfo">warnings</a>
                                                        and the <a :href="faqURL + '#doing-right-footage'" target="_blank">Doing right footage</a>
                                                        section
                                                        of the FAQ.
                                                    </template>
                                                    <template v-else>Check <a :href="faqURL + '#doing-right-footage'" target="_blank">Doing right
                                                        footage</a> section of the FAQ.
                                                    </template>
                                                </p>
                                                <p class="m-3" v-if="vPR.criticalErrorFlag">Please, <a
                                                    style="color: black; text-decoration: underline" href="#"
                                                    @click.prevent="$emit('uploadNewVideoOnErrorMsgClick')">upload</a> another video or retry.
                                                </p>
                                            </template>
                                        </div>
                                    </CRow>

                                    <CRow class="mt-2" v-if="!activeTabVideoAvailableFlag || vPR.criticalErrorFlag">
                                        <CCol sm="6">
                                        </CCol>
                                        <CCol sm="6" class="video-date text-md-right text-sm-left">
                                            <span style="padding-right:1em">Added by {{ training.owner.username }}</span>
                                            <span> {{ formatDateTime(training.createdAt) }} </span>
                                        </CCol>
                                    </CRow>

                                    <CRow class="mt-4 align-items-center comment" v-for="comment of training.comments"
                                          :key="comment.id">
                                        <CCol col="2" sm="1" style="min-width: 67px!important">
                                            <div style="margin-left: 5px; height:36px; width:36px;min-width:36px"
                                                 class="c-avatar comment-avatar">
                                                <!--suppress HtmlRequiredAltAttribute -->
                                                <img
                                                    style="height:36px;width:36px;min-width:36px"
                                                    src="../assets/img/cil-user.png"
                                                    class="c-avatar-img"
                                                />
                                            </div>
                                            <div style="min-width:53px"> {{ comment.owner.username }}</div>
                                        </CCol>
                                        <CCol class="col">
                                            <p v-html="comment.text" class="mb-0 comment-text text-justify show" v-linkified/>
                                        </CCol>
                                        <CCol col="1" v-if="comment.owner.id === store.myUser.id">
                                            <CButton @click="deleteComment(comment.id)"
                                                     class="p-0 float-right">
                                                <!--suppress HtmlUnknownTag -->
                                                <CIcon size="lg" style="color:black" name="cil-x"/>
                                            </CButton>
                                        </CCol>
                                    </CRow>
                                    <CRow class="mt-4 align-items-center comment">
                                        <CCol col="2" sm="1" style="min-width: 67px!important">
                                            <div style="margin-left: 5px; height:36px;width:36px;min-width:36px"
                                                 class="c-avatar comment-avatar">
                                                <!--suppress HtmlRequiredAltAttribute -->
                                                <img
                                                    style="height:36px;width:36px;min-width:36px"
                                                    src="../assets/img/cil-user.png"
                                                    class="c-avatar-img "
                                                    @click="store.showStaffControls=!store.showStaffControls && store.myUser.isSuperuser"
                                                />
                                            </div>
                                        </CCol>
                                        <CCol class="col">
                                            <CTextarea
                                                class="mb-0"
                                                :addInputClasses="newCommentMultilineFlag ? '': 'new-comment-1row-textarea'"
                                                placeholder="Comment"
                                                v-model="newCommentText"
                                                :rows="newCommentMultilineFlag"
                                                @blur="newCommentMultilineFlag=false"
                                                @focus="newCommentMultilineFlag=true"
                                            >
                                                <template #append>
                                                    <CButton @click="addComment" color="info">Post</CButton>
                                                </template>
                                            </CTextarea>
                                        </CCol>
                                    </CRow>
                                </template>
                                <div v-if="showTranscodedVideoPlayer && video.videoProcessing && video.videoProcessing.transcodedVideo">
                                    <TranscodedVideoPlayer
                                        :videoFileId="video.videoProcessing.transcodedVideo.id"
                                        :posterFileId="video.videoProcessing.transcodedVideoPoster ? video.videoProcessing.transcodedVideoPoster.id : null"
                                        class="mb-4"
                                    />
                                </div>
                            </div>
                        </CCardBody>
                    </CCard>
                </CCol>
                <CCol xl="4" lg="5" v-show="!isActiveCompareTab">
                    <CRow v-if="vPR">
                        <CCol sm="6">
                            <CWidgetProgressIcon
                                class="widget-body pb-4"
                                :header="vPR.spmRounded === null ? ' ' :
                                    vPR.spmRounded.toString()"
                                text="strokes/min"
                                :color="vPR.spmRounded ? (vPR.spmRounded > 30 ? 'success' : 'info') : 'secondary'"
                                :value="vPR.spmRounded === null ? 0 : vPR.spmRounded/40 * 100"
                            >
                                <!--suppress HtmlUnknownTag -->
                                <CIcon name="cilRowing" height="36"/>
                                <template v-if="vPR.spmRounded === null && processingInProgress" slot="default">
                                    <Spinner/>
                                </template>
                                <small v-if="vPR.strokesQty"
                                       class="text-muted widget-text"
                                       slot="default"
                                >{{
                                        vPR.strokesQty + ' stroke' + (vPR.strokesQty > 1 ? 's' : '') + ' analyzed' +
                                        (vPR.spmRounded === null ? '' : (vPR.spmRounded >
                                        30 ? ' - intensive' : ' - relaxed'))
                                    }}
                                </small>
                            </CWidgetProgressIcon>

                            <CWidgetProgressIcon
                                v-if="vPR['checksPerStrokeQty'] !== 0 && training.trainingProfile.checksQty !== 0"
                                class="widget-body pb-4"
                                :header="vPR['avgScore'+ activeSeatNum] === null ? ' ' :   Math.round(vPR['avgScore'+ activeSeatNum]) + '%'"
                                :text="(participantsQty === 1 ? '' : (activeSeatNum ? 'athlete ' : 'crew ')) + training.trainingProfile.name + ' score'"
                                :color="vPR['avgScore'+ activeSeatNum] >= 80 ? 'success' : 'info'"
                                :value="vPR['avgScore'+ activeSeatNum] === null ? 0 : vPR['avgScore'+ activeSeatNum]"
                            >
                                <!--suppress HtmlUnknownTag -->
                                <CIcon name="cilGauge" height="36"/>
                                <template v-if="vPR['avgScore'+ activeSeatNum] === null && processingInProgress" slot="default">
                                    <Spinner/>
                                </template>
                                <small v-if="vPR['checksPerStrokeQty']"
                                       class="text-muted widget-text"
                                       slot="default"
                                >
                                    {{
                                        (vPR['checksPerStrokeQty'] - vPR['mismatchesPerStrokeQty' + activeSeatNum]).toFixed(1) + ' matches per stroke - ' + vPR['checksPerStrokeQty'] + ' checks'
                                    }}
                                </small>
                            </CWidgetProgressIcon>
                            <CWidgetProgressIcon
                                v-else
                                class="widget-body pb-4"
                                header=" "
                                :text="training.trainingProfile.name"
                                color="success"
                                :value="100"
                            >
                                <!--suppress HtmlUnknownTag -->
                                <CIcon name="cilGauge" height="36"/>
                                <small
                                    class="text-muted widget-text"
                                    slot="default"
                                >
                                    No checks
                                </small>
                            </CWidgetProgressIcon>
                        </CCol>
                        <CCol sm="6">
                            <CWidgetProgressIcon
                                class="widget-body pb-4"
                                :header="vPR.footageQuality === null ? ' ' :
                                   {1: 'Low', 2: 'Fair', 3: 'Good', 4: 'Perfect'}[vPR.footageQuality]"
                                text="footage quality"
                                :color="{4: 'success', 3: 'success', 2: 'info', 1: 'danger'}[vPR.footageQuality]"
                                :value="vPR.footageQuality === null ? 0 : vPR.footageQuality*25"
                            >
                                <!--suppress HtmlUnknownTag -->
                                <CIcon name="cilVideo" height="36"/>
                                <template v-if="vPR.footageQuality === null && processingInProgress" slot="default">
                                    <Spinner/>
                                </template>
                                <small
                                    class="text-muted widget-text"
                                    slot="default"
                                >
                                    {{
                                        {
                                            1: 'Analysis can be inaccurate',
                                            2: 'Analysis can be inaccurate',
                                            3: 'Likely accurate analysis',
                                            4: 'Analysis is accurate'
                                        }[vPR.footageQuality]
                                    }}{{ vPR.footageQuality !== -1 && warningsInfo && Object.keys(warningsInfo).length ? '.' : '' }}
                                    <template v-if="warningsInfo && Object.keys(warningsInfo).length">
                                        <a href="#" @click.prevent="toggleWarningsInfo">Check</a>
                                        {{ Object.keys(warningsInfo).length }} {{ 'warning' + (Object.keys(warningsInfo).length > 1 ? 's' : '') }}
                                    </template>
                                </small>
                            </CWidgetProgressIcon>
                        </CCol>
                    </CRow>
                </CCol>
            </CRow>
        </template>
    </div>
</template>

<script>
    import Spinner from '@/components/Spinner'
    import TranscodedVideoPlayer from '@/components/TranscodedVideoPlayer'
    import RowingVideo from '@/components/RowingVideo'
    import SelectAthlete from '@/components/SelectAthlete'
    import {store} from '@/scripts/globals'
    import {apolloClient} from '@/plugins/apollo'
    import gql from 'graphql-tag'
    import trainingParticipantsAndPrivacyMixin from '@/mixins/training-participants-and-privacy'
    import fileUtils from "@/mixins/file-utils"
    import router from '@/plugins/router'
    import {backendURL} from '@/scripts/globals'
    import {
        getTrainingParticipantName,
        getTrainingParamsArrForUrl,
        getTrainingParamsFromVars,
        getTrainingParamsUrlPart,
    } from "@/scripts/training-utils"
    import VueScrollTo from 'vue-scrollto'
    import {isMobileOnly} from 'mobile-device-detect';
    import moment from "moment/moment";
    import {getDateFormat} from '@/scripts/utils';
    import {hasPermission} from "@/scripts/auth-utils";

    const compare_seats_min = 2;
    const compare_seats_max = 4;

    let warningsSlugs = [
        'small_pose_2d_median_back_length_pixels',
        'extremely_low_pose_2d_found_ds_percent_after_trim',
        'big_y_angle',
        'pose_2d_not_in_frame_with_padding_high_percent',
        'short_dataset',
        'athlete_too_close',
        'slow_motion_detected',
        'high_strokes_durations_minmax_ratio',
        'high_strokes_pose_proj_median_back_lengths_minmax_ratio',
        'high_strokes_minmax_mean_pose_3d_angle_deviations_from_y3d_diff',
        'high_pose_2d_found_trimmed_duration',
        'original_video_was_downscaled_before_processing',
        'video_is_too_long'
    ]

    export default {
        components: {
            Spinner,
            TranscodedVideoPlayer,
            RowingVideo,
            SelectAthlete
        },
        props: {
            training: {},
            doPreload: {},
            feedType: {}
        },
        mixins: [trainingParticipantsAndPrivacyMixin, fileUtils],
        data() {
            let activeTab = this.$route.params.activeTab ? this.$route.params.activeTab : 'seat1'
            return {
                store,
                showDeleteQuestionMainPanel: false,
                showPanel: ['main', 'trainingSettings', 'warningsInfo'][0],
                showTranscodedVideoPlayer: false,

                newCommentText: '',
                newCommentMultilineFlag: false,
                participantInitialSelectorValue: {
                    1: null,
                    2: null,
                    3: null,
                    4: null,
                    5: null,
                    6: null,
                    7: null,
                    8: null,
                },
                activeTab,

                maxAllowedSrcVideosViewsPerDay: parseInt(process.env.VUE_APP_MAX_ALLOWED_SRC_VIDEOS_VIEWES_PER_DAY),
                faqURL: router.resolve({name: 'faq'}).href,
                backendURL,
                CCardHeaderId: 'training'+ this.training.id,
                compareWithTraining: null,
                playersReportSrcVideoTime: {},
                fullscreenMode: false,
            }
        },
        methods: {
            getTrainingPrivacy() {
                let privacy
                if (this.training.accessForAll)
                    privacy = 'Public'
                else if (this.training.accessForParticipants)
                    privacy = 'Participants'
                else
                    privacy = 'Private'
                return privacy
            },
            preparePrivacySettings() {
                if (!this.training.isNotAccessible) {
                    this.privacy = this.getTrainingPrivacy()
                    this.participant = {
                        1: this.training.participant1,
                        2: this.training.participant2,
                        3: this.training.participant3,
                        4: this.training.participant4,
                        5: this.training.participant5,
                        6: this.training.participant6,
                        7: this.training.participant7,
                        8: this.training.participant8,
                    }
                    this.participantCustomName = {
                        1: this.training.participant1CustomName,
                        2: this.training.participant2CustomName,
                        3: this.training.participant3CustomName,
                        4: this.training.participant4CustomName,
                        5: this.training.participant5CustomName,
                        6: this.training.participant6CustomName,
                        7: this.training.participant7CustomName,
                        8: this.training.participant8CustomName,
                    }
                    this.setInitialParticipantPlaceholder()

                    this.customPrivacyIds = []
                    this.customPrivacyOpts = {}

                    for (let user of this.training.accessForUsers) {
                        let customPrivacyId = this.addCustomPrivacy()
                        this.customPrivacyOpts[customPrivacyId] = user
                    }
                    this.addCustomPrivacy()
                }
            },
            getDateFormat() {
                return getDateFormat();
            },
            async addComment() {
                if (this.newCommentText) {
                    let mutation = gql`
                        mutation addComment ($trainingId: ID!, $text: String!){
                            addComment (trainingId: $trainingId, text: $text)
                            {
                                comment {
                                    id
                                }
                            }
                        }
                        `
                    await apolloClient.mutate({
                        mutation,
                        variables: {
                            trainingId: this.training.id,
                            text: this.newCommentText
                        }
                    })
                    this.newCommentText = ''
                    this.$emit('updateThis')
                }
            },
            async deleteComment(commentId) {
                let mutation = gql`
                           mutation {
                                   deleteComment(commentId: ${commentId}) {
                                       success
                                   }
                               }
                           `
                await apolloClient.mutate({
                    mutation
                })
                this.$emit('updateThis')
            },
            async deleteTraining() {
                this.$emit('deleteThis')
            },
            onSelectorChanged() {
            },
            async changePrivacy() {
                let accessForAll = this.privacy === 'Public'
                let accessForParticipants = this.privacy === 'Participants'
                let accessForUserIds = []
                for (let customPrivacyId of this.customPrivacyIds)
                    if (this.customPrivacyOpts[customPrivacyId])
                        accessForUserIds.push(parseInt(this.customPrivacyOpts[customPrivacyId].id))

                let inputTypeVars = {
                    trainingId: this.training.id,
                    accessForAll,
                    accessForUserIds,
                    accessForParticipants,
                    participant1CustomName: this.participantCustomName[1],
                    participant2CustomName: this.participantCustomName[2],
                    participant3CustomName: this.participantCustomName[3],
                    participant4CustomName: this.participantCustomName[4],
                    participant5CustomName: this.participantCustomName[5],
                    participant6CustomName: this.participantCustomName[6],
                    participant7CustomName: this.participantCustomName[7],
                    participant8CustomName: this.participantCustomName[8],
                    participant1Id: this.participant[1] ? this.participant[1].id : null,
                    participant2Id: this.participant[2] ? this.participant[2].id : null,
                    participant3Id: this.participant[3] ? this.participant[3].id : null,
                    participant4Id: this.participant[4] ? this.participant[4].id : null,
                    participant5Id: this.participant[5] ? this.participant[5].id : null,
                    participant6Id: this.participant[6] ? this.participant[6].id : null,
                    participant7Id: this.participant[7] ? this.participant[7].id : null,
                    participant8Id: this.participant[8] ? this.participant[8].id : null,
                }

                let mutation = gql`
                        mutation updateTraining ($updateTraining: UpdateTrainingInputType!){
                            updateTraining (updateTraining: $updateTraining)
                            {
                                training {
                                    id
                                }
                            }
                        }
                        `
                await apolloClient.mutate({
                    mutation,
                    variables: {updateTraining: inputTypeVars}
                })
                this.showPanel = 'main'
                this.$emit('updateThis')
            },
            participantName(seatNum) {
                return getTrainingParticipantName(this.training, seatNum)
            },
            seatName(seatNum) {
                return this.participantName(seatNum) || ('Seat ' + seatNum)
            },
            onActiveTabChanged() {
                if (!this.tabs.includes(this.activeTab)) {
                    this.activeTab = this.tabs[0]
                    return
                }

                if (this.activeTab === 'source' && !this.training.inMyTrainingsFlag && this.store.myUser.lastViewedSrcTrainingsIds.indexOf(this.training.id) === -1)
                    this.store.myUser.lastViewedSrcTrainingsIds.push(this.training.id)

                if (this.feedType === 'training') {
                    let newTrainingParams = getTrainingParamsFromVars(this.training, this.store.myUser, this.activeTab, this.playersReportSrcVideoTime[this.activeTab])
                    if (getTrainingParamsUrlPart(newTrainingParams) !== getTrainingParamsUrlPart(this.trainingParams)) {
                        router.push({
                            name: 'training', params: {
                                trainingId: this.training.id,
                                activeTab: this.acactiveSeatNumtiveTab,
                                trainingParams: getTrainingParamsArrForUrl(newTrainingParams)
                            }
                        })
                    }
                }
            },
            toggleWarningsInfo() {
                if (this.showPanel === 'warningsInfo')
                    this.showPanel = 'main'
                else
                    this.showPanel = 'warningsInfo'
                setTimeout(this.scrollToTrainingBlockIfNotVisible)
            },
            scrollToTrainingBlockIfNotVisible() {
                function checkVisible(elm) {
                    let rect = elm.getBoundingClientRect();
                    let viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight);
                    return !(rect.bottom < 0 || rect.top - viewHeight >= 0);
                }

                let elm = window.document.getElementById(this.CCardHeaderId)
                if (!checkVisible(elm))
                    VueScrollTo.scrollTo(elm)
            },
            clickCompare() {
                if (this.isCompare2xAvailable) {
                    this.activeTab = 'compare';
                }
            },
            clickCompareErg() {
                if (this.isCompare1xAvailable) {
                    this.activeTab = 'compareErg';
                }
            },
            formatDateTime(dateStr) {
                return moment.utc(dateStr).local().format(`${this.getDateFormat()} HH:mm`)
            },
            changedComparedAthlete(training) {
                this.compareWithTraining = training;
            },
            toggleFullscreen() {
                this.fullscreenMode = !this.fullscreenMode;
            },
        },
        computed: {
            trainingUrl() {
                return window.location.protocol + '//' + window.location.host + router.resolve({
                        name: 'training',
                        params: {trainingId: this.training.id, activeTab: this.activeTab, trainingParams: this.trainingParamsArrForUrl},
                    }
                ).href
            },
            trainingParams() {  // main point of info streams
                return getTrainingParamsFromVars(this.training, this.store.myUser, this.activeTab, this.reportSrcVideoTime)
            },
            trainingParamsArrForUrl() {
                return getTrainingParamsArrForUrl(this.trainingParams)
            },
            boatType() {
                return this.training.boatType
            },
            activeSeatNum() {
                if (this.activeTab.slice(0, 4) === 'seat')
                    return parseInt(this.activeTab[4])
                else
                    return ''
            },
            video() {
                return this.training.videos[0]
            },
            vPR() {
                return this.video.videoProcessingResult
            },
            activeTabVideoAvailableFlag() {
                if (this.activeTab.slice(0, 4) === 'seat')
                    return this.vPR['reportPcVideo' + this.activeTab[4]]
                else if (this.activeTab === 'source')
                    return this.vPR['reportSrcVideo']
                else if (this.activeTab === 'compare') {
                    let hasVideo = false;
                    this.tabs.every(tab => {
                        if (tab.slice(0, 4) === 'seat' && this.vPR['reportPcVideo' + tab[4]]) {
                            hasVideo = true;
                            return false; //break the loop
                        }
                        return true; //continue
                    });
                    return hasVideo;
                } else if (this.activeTab === 'compareErg') {
                    return !!this.vPR['reportPcVideo1'];
                } else
                    return false
            },
            sourceAllowedFlag() {
                return this.store.myUser.isSuperuser || this.training.inMyTrainingsFlag || store.myUser.lastViewedSrcTrainingsIds.length < this.maxAllowedSrcVideosViewsPerDay || store.myUser.lastViewedSrcTrainingsIds.indexOf(this.training.id) !== -1
            },
            tabs() {
                let tabs = ['source', 'seat1', 'seat2', 'seat3', 'seat4', 'seat5', 'seat6', 'seat7', 'seat8']
                    .slice(this.sourceAllowedFlag ? 0 : 1, this.participantsQty + 1);

                //Configure
                if (this.participantsQty >= compare_seats_min && this.participantsQty <= compare_seats_max) {
                    tabs.push('compare');
                }

                //Configure this others
                if (
                    this.training.equipmentType === 'ERG'
                    || (this.training.equipmentType === 'BOAT' && this.training.boatType === 'CREW1X')
                ) {
                    tabs.push('compareErg');
                }

                return tabs;
            },
            processingInProgress() {
                return !this.vPR.criticalErrorFlag && !this.vPR.finishedAt
            },
            warningsInfo() {
                if (this.vPR.analysisWarningsInfo) {
                    let warnings = JSON.parse(this.vPR.analysisWarningsInfo)
                    let orderedWarnings = Object()
                    let qty = 0
                    for (let slug of warningsSlugs) {
                        if (slug in warnings) {
                            orderedWarnings[slug] = warnings[slug]
                            qty += 1
                            if (qty >= 3)
                                break
                        }
                    }
                    return orderedWarnings
                } else
                    return null
            },
            showCompareTab() {
                return this.tabs.includes('compare') && this.vPR && this.activeTabVideoAvailableFlag && !this.vPR.criticalErrorFlag;
            },
            showCompareErgTab() {
                return this.tabs.includes('compareErg') && this.vPR && this.activeTabVideoAvailableFlag && !this.vPR.criticalErrorFlag;
            },
            isCompare1xAvailable() {
                return hasPermission('compare_1x');
            },
            isCompare2xAvailable() {
                return hasPermission('compare_2x');
            },
            columnTrainingsProps() {
                return ['compareErg', 'compare'].includes(this.activeTab)
                    ? {'col': 12}
                    : {'lg': 7, 'xl': 6};
            },
            isActiveCompareTab() {
                return ['compare', 'compareErg'].includes(this.activeTab);
            }
        },
        watch: {
            'training.updatedAt': function () {
                this.preparePrivacySettings()
            },
            trainingParams: function (newTrainingParams, prevTrainingParams) {
                if (this.feedType === 'training' && getTrainingParamsUrlPart(newTrainingParams) !== getTrainingParamsUrlPart(prevTrainingParams)) {
                    router.push({
                        name: 'training', params: {
                            trainingId: this.training.id,
                            activeTab: this.activeTab,
                            trainingParams: getTrainingParamsArrForUrl(newTrainingParams)
                        }
                    })
                }
            },
            activeTab: function () {
                this.onActiveTabChanged()
            },
            showPanel(newVal, oldVal) {
                if (oldVal === 'trainingSettings')
                    this.preparePrivacySettings()
            }
        },
        created() {
            this.preparePrivacySettings()
            this.onActiveTabChanged()

            document.addEventListener('keydown', (event) => {
                if (event.key === 'Escape' && this.fullscreenMode) {
                    this.toggleFullscreen();
                }
            });
        }
    }
</script>

<style lang="scss">
    @media screen and (max-width: 992px) {
        .widget-body {
            .h1 {
                margin-bottom: 0 !important;
            }

            svg {
                position: absolute;
                right: 1.25em;
            }
        }
    }

    @media screen and (max-width: 768px) {
        .video {
            &-error {
                padding-left: 0 !important;

                .col {
                    padding-left: 15px !important;
                }
            }
        }
    }

    @media screen and (max-width: 576px) {
        .comment {
            &-avatar {
                width: 35px !important;
                min-width: 35px !important;
                height: 35px !important;

                img {
                    width: 35px !important;
                    min-width: 35px !important;
                    height: 35px !important;
                }
            }
        }
        .embed-responsive {
            &:before {
                padding-top: 75% !important;
            }
        }
        .video {
            &-date {
                text-align: left !important;
            }

            &-analyzing {
                /*height: 300px !important;*/
                flex-direction: column;
                justify-content: center !important;

                &.video-error {
                    flex-direction: row;
                }

                .progress {
                    margin-bottom: 2em;
                }
            }

            &-select {
                label {
                    margin-bottom: 0.5em !important;
                }
            }

            &-types {
                margin-bottom: 0.75em !important;
            }
        }
    }

    .no-click {
        pointer-events: none;
    }

    .activeTabButton {
        color: #4f5d73 !important;
        background-color: #d6dade !important;
        border-color: #cfd4d8 !important;
    }

    .blue-tab:not(.activeTabButton) {
        background-color: #39f !important;
        color:#fff !important;
    }

    .widget-text {
        position: absolute;
        font-size: 11px;
        left: 1.7em;
        padding-right: 1.7em;
        bottom: 2em;
        text-align: left;
        min-width: 164px;
    }

    .linkDisabled {
        cursor: not-allowed;
        opacity: 0.5;
        text-decoration: none;
        pointer-events: none;
    }

    .new-comment-1row-textarea {
        resize: none;
        height: 35px !important;
    }

    .rowing-analysis-warning-level-3 {
        list-style: disc;
    }

    .rowing-analysis-warning-level-3::marker {
        color: #e55353;
        font-size: 125%;
    }

    .rowing-analysis-warning-level-2 {
        list-style: disc
    }

    .rowing-analysis-warning-level-2::marker {
        color: #39f;
        font-size: 125%;
    }

    .rowing-analysis-warning-level-1 {
        list-style: disc
    }

    .rowing-analysis-warning-level-1::marker {
        padding-top: 10px;
        color: #2eb85c;
        font-size: 125%;
    }

    .rowing-analysis-warning-level-0 {
        list-style: disc
    }

    .rowing-analysis-warning-level-0::marker {
        padding-top: 10px;
        color: #2eb85c;
        font-size: 125%;
    }

    .rowing-header-buttons {
        display: flex;
        flex-wrap: wrap;
        column-gap: 0.5em;
        row-gap: 0.2em;
    }
    .c-avatar .c-avatar-img {
        border-radius: 0;
    }
    .training .card {
        transition: all 1s ease;
    }
    body:has(.fullscreen-mode) {
        overflow: hidden;
    }
    .fullscreen-mode {
        .card {
            position: fixed;
            z-index: 9999;
            top: 0;
            left: 0;
            width: 100vw;
            height: 100vh;


            .card-header {
                position: absolute;
                z-index: 10;
                top: 0;
                left: 0;
                width: 100%;
                transition: opacity 2s ease;
                opacity: 0;
            }

            .card-header:not(:hover) {
                transition-delay: 1s;
            }

            .card-header:hover {
                opacity: 1;
                transition: opacity 0s;
            }

            .rowing-header-buttons {
                flex: 0 0 100%;
                max-width: 100%;
                justify-content: center;
                row-gap: 5px;
            }

            .card-body {
                overflow-y: auto;
                padding: 0 !important;

                .video-container__player-wrapper {
                    padding: 0 !important;
                }

                .video-container > .row {
                    margin: 0 !important;
                }

                .compare {
                    max-height: 100vh;
                }
            }

            .comment, .training-menu, .video-pdf, .seats-btn, .source-btn, .compare-btn, .athlete-badge {
                display: none !important;
            }
            .video-list {
                height: 99.5vh;
            }
            @media (orientation: landscape) {
                .video-container__player-wrapper {
                    max-height: 100vh;
                    max-width: 49.6vw;
                }
                .video-list {
                    align-content: center;
                    justify-content: center;
                }
            }
            @media (orientation: portrait) {
                .video-container__player-wrapper {
                    max-width: 100vw;
                }
            }
        }
    }
</style>
